import React from 'react';
import { Layer, Rect } from 'react-konva';
import { useMapCanvas } from '../../contexts/MapCanvasContext';

export const MapCanvasEditingAreaLayer: React.FC = () => {
  const { editingZoneWidth, editingZoneHeight, isDark } = useMapCanvas();
  return (
    <Layer>
      <Rect
        id="editing-zone"
        width={editingZoneWidth}
        height={editingZoneHeight}
        x={0}
        y={0}
        fill={isDark ? 'black' : 'white'}
        shadowColor="rgba(0, 0, 0, 0.15)"
        shadowBlur={20}
        shadowOffset={{ x: 0, y: 0 }}
        shadowOpacity={1}
      />
    </Layer>
  );
};
